import cn from 'classnames';
import { FC, HTMLProps } from 'react';
import s from './page.module.css';

export interface PageProps extends HTMLProps<HTMLDivElement> {}

export const Page: FC<PageProps> = (props) => {
  const { className, ...other } = props;
  return <div className={cn(s.component, className)} data-testid="page" {...other} />;
};
